(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object')
    module.exports = factory();
  else if (typeof define === 'function' && define.amd)
    define([], factory);
  else {
    var a = factory();
    for (var i in a)(typeof exports === 'object' ? exports : root)[i] = a[i];
  }
})(window, function () {
  return /******/ (function (modules) { // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/
      /******/ // Check if module is in cache
      /******/
      if (installedModules[moduleId]) {
        /******/
        return installedModules[moduleId].exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/
        i: moduleId,
        /******/
        l: false,
        /******/
        exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/
      /******/ // Flag the module as loaded
      /******/
      module.l = true;
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/
    __webpack_require__.c = installedModules;
    /******/
    /******/ // define getter function for harmony exports
    /******/
    __webpack_require__.d = function (exports, name, getter) {
      /******/
      if (!__webpack_require__.o(exports, name)) {
        /******/
        Object.defineProperty(exports, name, {
          enumerable: true,
          get: getter
        });
        /******/
      }
      /******/
    };
    /******/
    /******/ // define __esModule on exports
    /******/
    __webpack_require__.r = function (exports) {
      /******/
      if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
        /******/
        Object.defineProperty(exports, Symbol.toStringTag, {
          value: 'Module'
        });
        /******/
      }
      /******/
      Object.defineProperty(exports, '__esModule', {
        value: true
      });
      /******/
    };
    /******/
    /******/ // create a fake namespace object
    /******/ // mode & 1: value is a module id, require it
    /******/ // mode & 2: merge all properties of value into the ns
    /******/ // mode & 4: return value when already ns object
    /******/ // mode & 8|1: behave like require
    /******/
    __webpack_require__.t = function (value, mode) {
      /******/
      if (mode & 1) value = __webpack_require__(value);
      /******/
      if (mode & 8) return value;
      /******/
      if ((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
      /******/
      var ns = Object.create(null);
      /******/
      __webpack_require__.r(ns);
      /******/
      Object.defineProperty(ns, 'default', {
        enumerable: true,
        value: value
      });
      /******/
      if (mode & 2 && typeof value != 'string')
        for (var key in value) __webpack_require__.d(ns, key, function (key) {
          return value[key];
        }.bind(null, key));
      /******/
      return ns;
      /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/
    __webpack_require__.n = function (module) {
      /******/
      var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
      /******/
      __webpack_require__.d(getter, 'a', getter);
      /******/
      return getter;
      /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/
    __webpack_require__.o = function (object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/
    __webpack_require__.p = "";
    /******/
    /******/
    /******/ // Load entry module and return exports
    /******/
    return __webpack_require__(__webpack_require__.s = "./src/modal/index.js");
    /******/
  })
  /************************************************************************/
  /******/
  ({

    /***/
    "./node_modules/css-loader/dist/cjs.js!./node_modules/sass-loader/dist/cjs.js?!./src/modal/style.scss":
      /*!*********************************************************************************************************************!*\
        !*** ./node_modules/css-loader/dist/cjs.js!./node_modules/sass-loader/dist/cjs.js??ref--5-2!./src/modal/style.scss ***!
        \*********************************************************************************************************************/
      /*! no static exports found */
      /***/
      (function (module, exports, __webpack_require__) {

        // Imports
        var ___CSS_LOADER_API_IMPORT___ = __webpack_require__( /*! ../../node_modules/css-loader/dist/runtime/api.js */ "./node_modules/css-loader/dist/runtime/api.js");
        exports = ___CSS_LOADER_API_IMPORT___(false);
        // Module
        exports.push([module.i, "[data-modal] {\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.55);\n  z-index: 5; }\n  [data-modal] > div {\n    position: relative;\n    background-color: #FFF; }\n", ""]);
        // Exports
        module.exports = exports;


        /***/
      }),

    /***/
    "./node_modules/css-loader/dist/runtime/api.js":
      /*!*****************************************************!*\
        !*** ./node_modules/css-loader/dist/runtime/api.js ***!
        \*****************************************************/
      /*! no static exports found */
      /***/
      (function (module, exports, __webpack_require__) {

        "use strict";


        /*
          MIT License http://www.opensource.org/licenses/mit-license.php
          Author Tobias Koppers @sokra
        */
        // css base code, injected by the css-loader
        // eslint-disable-next-line func-names
        module.exports = function (useSourceMap) {
          var list = []; // return the list of modules as css string

          list.toString = function toString() {
            return this.map(function (item) {
              var content = cssWithMappingToString(item, useSourceMap);

              if (item[2]) {
                return "@media ".concat(item[2], " {").concat(content, "}");
              }

              return content;
            }).join('');
          }; // import a list of modules into the list
          // eslint-disable-next-line func-names


          list.i = function (modules, mediaQuery, dedupe) {
            if (typeof modules === 'string') {
              // eslint-disable-next-line no-param-reassign
              modules = [
                [null, modules, '']
              ];
            }

            var alreadyImportedModules = {};

            if (dedupe) {
              for (var i = 0; i < this.length; i++) {
                // eslint-disable-next-line prefer-destructuring
                var id = this[i][0];

                if (id != null) {
                  alreadyImportedModules[id] = true;
                }
              }
            }

            for (var _i = 0; _i < modules.length; _i++) {
              var item = [].concat(modules[_i]);

              if (dedupe && alreadyImportedModules[item[0]]) {
                // eslint-disable-next-line no-continue
                continue;
              }

              if (mediaQuery) {
                if (!item[2]) {
                  item[2] = mediaQuery;
                } else {
                  item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
                }
              }

              list.push(item);
            }
          };

          return list;
        };

        function cssWithMappingToString(item, useSourceMap) {
          var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

          var cssMapping = item[3];

          if (!cssMapping) {
            return content;
          }

          if (useSourceMap && typeof btoa === 'function') {
            var sourceMapping = toComment(cssMapping);
            var sourceURLs = cssMapping.sources.map(function (source) {
              return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
            });
            return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
          }

          return [content].join('\n');
        } // Adapted from convert-source-map (MIT)


        function toComment(sourceMap) {
          // eslint-disable-next-line no-undef
          var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
          var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
          return "/*# ".concat(data, " */");
        }

        /***/
      }),

    /***/
    "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js":
      /*!****************************************************************************!*\
        !*** ./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js ***!
        \****************************************************************************/
      /*! no static exports found */
      /***/
      (function (module, exports, __webpack_require__) {

        "use strict";


        var isOldIE = function isOldIE() {
          var memo;
          return function memorize() {
            if (typeof memo === 'undefined') {
              // Test for IE <= 9 as proposed by Browserhacks
              // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
              // Tests for existence of standard globals is to allow style-loader
              // to operate correctly into non-standard environments
              // @see https://github.com/webpack-contrib/style-loader/issues/177
              memo = Boolean(window && document && document.all && !window.atob);
            }

            return memo;
          };
        }();

        var getTarget = function getTarget() {
          var memo = {};
          return function memorize(target) {
            if (typeof memo[target] === 'undefined') {
              var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

              if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
                try {
                  // This will throw an exception if access to iframe is blocked
                  // due to cross-origin restrictions
                  styleTarget = styleTarget.contentDocument.head;
                } catch (e) {
                  // istanbul ignore next
                  styleTarget = null;
                }
              }

              memo[target] = styleTarget;
            }

            return memo[target];
          };
        }();

        var stylesInDom = [];

        function getIndexByIdentifier(identifier) {
          var result = -1;

          for (var i = 0; i < stylesInDom.length; i++) {
            if (stylesInDom[i].identifier === identifier) {
              result = i;
              break;
            }
          }

          return result;
        }

        function modulesToDom(list, options) {
          var idCountMap = {};
          var identifiers = [];

          for (var i = 0; i < list.length; i++) {
            var item = list[i];
            var id = options.base ? item[0] + options.base : item[0];
            var count = idCountMap[id] || 0;
            var identifier = "".concat(id, " ").concat(count);
            idCountMap[id] = count + 1;
            var index = getIndexByIdentifier(identifier);
            var obj = {
              css: item[1],
              media: item[2],
              sourceMap: item[3]
            };

            if (index !== -1) {
              stylesInDom[index].references++;
              stylesInDom[index].updater(obj);
            } else {
              stylesInDom.push({
                identifier: identifier,
                updater: addStyle(obj, options),
                references: 1
              });
            }

            identifiers.push(identifier);
          }

          return identifiers;
        }

        function insertStyleElement(options) {
          var style = document.createElement('style');
          var attributes = options.attributes || {};

          if (typeof attributes.nonce === 'undefined') {
            var nonce = true ? __webpack_require__.nc : undefined;

            if (nonce) {
              attributes.nonce = nonce;
            }
          }

          Object.keys(attributes).forEach(function (key) {
            style.setAttribute(key, attributes[key]);
          });

          if (typeof options.insert === 'function') {
            options.insert(style);
          } else {
            var target = getTarget(options.insert || 'head');

            if (!target) {
              throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            }

            target.appendChild(style);
          }

          return style;
        }

        function removeStyleElement(style) {
          // istanbul ignore if
          if (style.parentNode === null) {
            return false;
          }

          style.parentNode.removeChild(style);
        }
        /* istanbul ignore next  */


        var replaceText = function replaceText() {
          var textStore = [];
          return function replace(index, replacement) {
            textStore[index] = replacement;
            return textStore.filter(Boolean).join('\n');
          };
        }();

        function applyToSingletonTag(style, index, remove, obj) {
          var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

          /* istanbul ignore if  */

          if (style.styleSheet) {
            style.styleSheet.cssText = replaceText(index, css);
          } else {
            var cssNode = document.createTextNode(css);
            var childNodes = style.childNodes;

            if (childNodes[index]) {
              style.removeChild(childNodes[index]);
            }

            if (childNodes.length) {
              style.insertBefore(cssNode, childNodes[index]);
            } else {
              style.appendChild(cssNode);
            }
          }
        }

        function applyToTag(style, options, obj) {
          var css = obj.css;
          var media = obj.media;
          var sourceMap = obj.sourceMap;

          if (media) {
            style.setAttribute('media', media);
          } else {
            style.removeAttribute('media');
          }

          if (sourceMap && btoa) {
            css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
          } // For old IE

          /* istanbul ignore if  */


          if (style.styleSheet) {
            style.styleSheet.cssText = css;
          } else {
            while (style.firstChild) {
              style.removeChild(style.firstChild);
            }

            style.appendChild(document.createTextNode(css));
          }
        }

        var singleton = null;
        var singletonCounter = 0;

        function addStyle(obj, options) {
          var style;
          var update;
          var remove;

          if (options.singleton) {
            var styleIndex = singletonCounter++;
            style = singleton || (singleton = insertStyleElement(options));
            update = applyToSingletonTag.bind(null, style, styleIndex, false);
            remove = applyToSingletonTag.bind(null, style, styleIndex, true);
          } else {
            style = insertStyleElement(options);
            update = applyToTag.bind(null, style, options);

            remove = function remove() {
              removeStyleElement(style);
            };
          }

          update(obj);
          return function updateStyle(newObj) {
            if (newObj) {
              if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
                return;
              }

              update(obj = newObj);
            } else {
              remove();
            }
          };
        }

        module.exports = function (list, options) {
          options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
          // tags it will allow on a page

          if (!options.singleton && typeof options.singleton !== 'boolean') {
            options.singleton = isOldIE();
          }

          list = list || [];
          var lastIdentifiers = modulesToDom(list, options);
          return function update(newList) {
            newList = newList || [];

            if (Object.prototype.toString.call(newList) !== '[object Array]') {
              return;
            }

            for (var i = 0; i < lastIdentifiers.length; i++) {
              var identifier = lastIdentifiers[i];
              var index = getIndexByIdentifier(identifier);
              stylesInDom[index].references--;
            }

            var newLastIdentifiers = modulesToDom(newList, options);

            for (var _i = 0; _i < lastIdentifiers.length; _i++) {
              var _identifier = lastIdentifiers[_i];

              var _index = getIndexByIdentifier(_identifier);

              if (stylesInDom[_index].references === 0) {
                stylesInDom[_index].updater();

                stylesInDom.splice(_index, 1);
              }
            }

            lastIdentifiers = newLastIdentifiers;
          };
        };

        /***/
      }),

    /***/
    "./src/modal/index.js":
      /*!****************************!*\
        !*** ./src/modal/index.js ***!
        \****************************/
      /*! exports provided: default */
      /***/
      (function (module, __webpack_exports__, __webpack_require__) {

        "use strict";
        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */
        __webpack_require__.d(__webpack_exports__, "default", function () {
          return Modal;
        });
        /* harmony import */
        var _style_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__( /*! ./style.scss */ "./src/modal/style.scss");
        /* harmony import */
        var _style_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_style_scss__WEBPACK_IMPORTED_MODULE_0__);

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _defineProperties(target, props) {
          for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
          }
        }

        function _createClass(Constructor, protoProps, staticProps) {
          if (protoProps) _defineProperties(Constructor.prototype, protoProps);
          if (staticProps) _defineProperties(Constructor, staticProps);
          return Constructor;
        }

        function _defineProperty(obj, key, value) {
          if (key in obj) {
            Object.defineProperty(obj, key, {
              value: value,
              enumerable: true,
              configurable: true,
              writable: true
            });
          } else {
            obj[key] = value;
          }
          return obj;
        }

        function _classPrivateFieldGet(receiver, privateMap) {
          var descriptor = privateMap.get(receiver);
          if (!descriptor) {
            throw new TypeError("attempted to get private field on non-instance");
          }
          if (descriptor.get) {
            return descriptor.get.call(receiver);
          }
          return descriptor.value;
        }

        function _classPrivateFieldSet(receiver, privateMap, value) {
          var descriptor = privateMap.get(receiver);
          if (!descriptor) {
            throw new TypeError("attempted to set private field on non-instance");
          }
          if (descriptor.set) {
            descriptor.set.call(receiver, value);
          } else {
            if (!descriptor.writable) {
              throw new TypeError("attempted to set read only private field");
            }
            descriptor.value = value;
          }
          return value;
        }



        var Modal = /*#__PURE__*/ function () {
          function Modal() {
            var _this = this;

            var modalTrigger;

            var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            _classCallCheck(this, Modal);

            _opts.set(this, {
              writable: true,
              value: void 0
            });

            _lock.set(this, {
              writable: true,
              value: 0
            });

            _data.set(this, {
              writable: true,
              value: {}
            });

            _template.set(this, {
              writable: true,
              value: false
            });

            _defineProperty(this, "handleLock", function (e) {
              window.scrollTo(0, _classPrivateFieldGet(_this, _lock));
            });

            _defineProperty(this, "handeClick", function (e) {


              if (e.target.closest("[data-modal-open=\"".concat(_this.id, "\"]"))) {

                //===== ADDED FOR ADA COMPLIANCE, ADD  ARIA-MODAL="TRUE" ARIA-HIDDEN="FALSE" TO MODAL CONTENT ON OPEN //

                document.querySelector(`#${_this.id}`).setAttribute('aria-modal', 'true');
                document.querySelector(`#${_this.id}`).setAttribute('aria-hidden', 'false');
                _this.open = true;

                //===== END OF ADDED ADA RULE //


                modalTrigger = document.getElementById(e.target.closest('[data-modal-open]').id);


                const activeModalContent = document.querySelector('[data-modal=' + _this.id + '] aside'),
                  activeModalButton = document.querySelector('[data-modal=' + _this.id + '] button');

                activeModalContent.focus();

                /* 
                  NOT SURE IF TO ACTIVATE FUNCTION - 
                  when modal open a deep link will be added 
                  so the client can share the link that will 
                  open a specific modal
                */
                // let fullURL = window.location.href
                // window.location.href = fullURL + "&modal" + _this.id

              }

              if (e.target.closest("[data-modal-close=\"".concat(_this.id, "\"]"))) {

                //===== ADDED FOR ADA COMPLIANCE, ADD ARIA-MODAL="FALSE" ARIA-HIDDEN="TRUE" TO MODAL CONTENT ON CLOSE //

                document.querySelector(`#${_this.id}`).setAttribute('aria-modal', 'false');
                document.querySelector(`#${_this.id}`).setAttribute('aria-hidden', 'true');


                //===== END OF ADDED ADA RULE //



                _this.open = false;

                if (modalTrigger) {
                  modalTrigger.focus();
                }

                /* START custom js for scrolling to section */
                function animate(elem, style, unit, from, to, time, prop) {
                  if (!elem) {
                    return;
                  }
                  var start = new Date().getTime(),
                    timer = setInterval(function () {
                      var step = Math.min(1, (new Date().getTime() - start) / time);
                      if (prop) {
                        elem[style] = (from + step * (to - from)) + unit;
                      } else {
                        elem.style[style] = (from + step * (to - from)) + unit;
                      }
                      if (step === 1) {
                        clearInterval(timer);
                      }
                    }, 25);
                  if (prop) {
                    elem[style] = from + unit;
                  } else {
                    elem.style[style] = from + unit;
                  }
                }
                let linkHash = e.target.hash;

                // If the close link containts a hash in destination, animate to that section
                if (linkHash) {
                  let sectionId = linkHash.replace('#', ''),
                    target = document.getElementById(sectionId),
                    scrollStartPosition = 0,
                    extraPadding = -48,
                    subNav = document.getElementById('subnav');

                  if (subNav) {
                    scrollStartPosition = subNav.offsetTop;
                  }

                  animate(document.scrollingElement || document.documentElement, "scrollTop", "", scrollStartPosition, (target.offsetTop + extraPadding), 500, true);
                }
                /* END custom js for scrolling to section */


                // If modal is opened due to link - will change URL to non-deep-link
                if (window.location.href.indexOf('&modal') != -1) {
                  let fullURL = window.location.href
                  const originalLink = fullURL.split('&modal')[0]
                  window.location.href = originalLink
                }

              }

              if (e.target.closest("[data-modal-exit]")) {
                _this.open = false;
              }
            });

            _classPrivateFieldSet(this, _opts, Object.assign({
              target: false
            }, opts));

            _classPrivateFieldSet(this, _template, document.getElementById(this.id).innerHTML);

            document.addEventListener("click", this.handeClick, {
              passive: false
            });

            // Able to open modal with a deep link: resources/#videos&modal[modal id] (example link: https://ongentyshcp.com/resources/#videos&modalvideo-modal-1)
            // if (window.location.href.indexOf('&modal') != -1) {
            //   let fullURL = window.location.href
            //   const parameteres = fullURL.split('&modal')[1]
            //   const parameterModal = document.querySelector('[data-modal-open=' + parameteres + ']')

            //   if (fullURL.indexOf('#') != -1) { // if the link has a scroll to id - will scroll to correct section
            //     let scrollToId = fullURL.split('#').pop().split('&modal')[0];
            //     let idOfSectionToScrollTo = document.getElementById(scrollToId)
            //     if (idOfSectionToScrollTo) {
            //       document.getElementById(scrollToId).scrollIntoView()
            //     }
            //   }

            //   if (parameterModal) { // make sure the modal link exists
            //     if (!document.querySelector('[data-modal=' + parameteres + ']')) { // make sure to click once
            //       parameterModal.click();
            //     }
            //   }

            // }
          }

          _createClass(Modal, [{
            key: "set",
            value: function set(prop, value) {
              Object.defineProperty(_classPrivateFieldGet(this, _data), prop, {
                value: value,
                writable: true,
                configurable: true,
                enumerable: true
              });
            }
          }, {
            key: "id",
            get: function get() {
              return _classPrivateFieldGet(this, _opts).target.id;
            }
          }, {
            key: "template",
            set: function set(data) {
              for (var prop in data) {
                _classPrivateFieldSet(this, _template, _classPrivateFieldGet(this, _template).replace(new RegExp("%%(".concat(prop.toUpperCase(), ")%%")), data[prop]));
              }
            },
            get: function get() {
              var string = this.content;

              for (var prop in _classPrivateFieldGet(this, _data)) {
                string = string.replace(new RegExp("%%(".concat(prop.toUpperCase(), ")%%")), _classPrivateFieldGet(this, _data)[prop]);
              }

              return string;
            }
          }, {
            key: "content",
            get: function get() {
              return document.getElementById(this.id).innerHTML;
            }
          }, {
            key: "modal",
            get: function get() {
              var wrapper__outer = document.createElement("div");
              wrapper__outer.setAttribute("data-modal", this.id);
              wrapper__outer.setAttribute("role", "popup");
              wrapper__outer.setAttribute("tabindex", 0);

              wrapper__outer.m = this;
              var wrapper__inner = document.createElement("div");
              wrapper__inner.innerHTML = this.template;
              wrapper__outer.appendChild(wrapper__inner);
              return wrapper__outer;
            }
          }, {
            key: "open",
            set: function set(visibility) {

              if (!visibility) {
                for (var _i = 0, _Array$from = Array.from(document.querySelectorAll("[data-modal=\"".concat(this.id, "\"]"))); _i < _Array$from.length; _i++) {
                  var modal = _Array$from[_i];

                  if (modal.m === this) {
                    modal.parentNode.removeChild(modal);
                    window.removeEventListener("scroll", this.handleLock);
                  }
                }
              } else {
                _classPrivateFieldSet(this, _lock, window.scrollY);

                this.template = _classPrivateFieldGet(this, _data);
                document.body.appendChild(this.modal);
                window.addEventListener("scroll", this.handleLock);
              }
            }
          }]);

          return Modal;
        }();

        var _opts = new WeakMap();

        var _lock = new WeakMap();

        var _data = new WeakMap();

        var _template = new WeakMap();


        window.Modal = Modal;

        /***/
      }),

    /***/
    "./src/modal/style.scss":
      /*!******************************!*\
        !*** ./src/modal/style.scss ***!
        \******************************/
      /*! no static exports found */
      /***/
      (function (module, exports, __webpack_require__) {

        var api = __webpack_require__( /*! ../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "./node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
        var content = __webpack_require__( /*! !../../node_modules/css-loader/dist/cjs.js!../../node_modules/sass-loader/dist/cjs.js??ref--5-2!./style.scss */ "./node_modules/css-loader/dist/cjs.js!./node_modules/sass-loader/dist/cjs.js?!./src/modal/style.scss");

        content = content.__esModule ? content.default : content;

        if (typeof content === 'string') {
          content = [
            [module.i, content, '']
          ];
        }

        var options = {};

        options.insert = "head";
        options.singleton = false;

        var update = api(content, options);

        var exported = content.locals ? content.locals : {};



        module.exports = exported;

        /***/
      })

    /******/
  });
});
//# sourceMappingURL=componentshc-modal.js.map